<template>
	<AppVMenu nudge-bottom="40">
		<template v-slot:activator="{ on, attrs }">
			<AnemicButton class="pa-0 ml-2 color-picker-button" rounded v-on="on" v-bind="attrs">
				<NotificationColorPickerSVG :color="`#${localValue}`" />
			</AnemicButton>
		</template>
		<Col class="color-plate-container flex-centerize px-2 py-2">
			<Row class="colors-grid flex-align-center flex-justify-space-around">
				<Col
					:key="color"
					v-for="color in colors"
					@click.native="localValue = color"
					:class="{ selected: color === localValue }"
					class="color-dot-container flex-centerize pa-1 my-1"
				>
					<Col class="color-dot" :style="{ background: `#${color}` }" />
				</Col>
			</Row>
		</Col>
	</AppVMenu>
</template>
<script>
import VModelMixin from '@/mixins/VModelMixin';
import NotificationColorPickerSVG from '@/components/BlockEditorNotification/CustomizeTabs/NotificationColorPickerSVG.vue';
export default {
	name: 'NotificationIconColorPicker',
	mixins: [VModelMixin],
	components: { NotificationColorPickerSVG },
	props: {
		colors: { type: Array },
	},
};
</script>
<style scoped lang="scss">
.color-picker-button {
	border: none !important;
	height: 35px !important;
	border-radius: 8px !important;
	background: var(--white) !important;
}

.color-plate-container {
	width: 95px;
	height: 66px;
	border-radius: 8px;
	background: #ffffff;
	border: 1px solid #e4e8f2;
	box-shadow: 0px 3px 6px #00000046;
}
.colors-grid {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
}
.color-dot-container {
	border-radius: 5px;
	&.selected {
		background: #e5effa;
		border: 1px solid #6092f0;
	}

	&:hover {
		cursor: pointer;
		background: #eeeffa;
		transition: var(--transition-time);
		box-shadow: 0px 3px 6px var(--shadow-color);
	}
	&:active {
		filter: brightness(0.9);
		transition: var(--transition-time);
	}
}
.color-dot {
	min-width: 16px;
	min-height: 16px;
	border-radius: 50%;
	border: 1px solid #e4e8f2;
}
</style>
